import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: false,
  errorCreating: null,
  isDeleting: false,
  errorDeleting: false,
  isUpdating: false,
  errorUpdating: null,
  selected: null,
  apartmentId: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.CREATE_USER:
      return {
        ...state,
        isCreating: true,
        errorCreating: null
      }
    case Types.CREATE_USER_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: null
      }
    case Types.CREATE_USER_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: payload
      }
    case Types.DELETE_USER:
      return {
        ...state,
        isDeleting: true,
        errorDeleting: false
      }
    case Types.DELETE_USER_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        errorDeleting: false
      }
    case Types.DELETE_USER_FAILED:
      return {
        ...state,
        isDeleting: false,
        errorDeleting: true
      }
    case Types.UPDATE_USER:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_USER_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    case Types.SHOW_EDIT_USER_MODAL:
      return {
        ...state,
        selected: payload
      }
    case Types.SHOW_NEW_USER_MODAL:
      return {
        ...state,
        apartmentId: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/Users.js